import { useSelector } from "react-redux";
import { Image } from "../image/image";
import { Text } from "../text/text";
import { levelNames } from "../../config/levelNames";
import { DEFAULT_ICON } from "../../config/constants";

import styles from "./header.module.css";

export const Header = ({ title = "", withData = true }) => {
    const { profilePhotoUrl, userData } = useSelector((state) => state.user);
    const { level, totalExp } = userData;

    const userLevel = level || 1;
    const photo = profilePhotoUrl || DEFAULT_ICON;

    const progress =
        (level >= levelNames.length) ? 0 :
            (levelNames[userLevel][1] - totalExp) / (levelNames[userLevel][1] - levelNames[userLevel - 1][1])

    return (
        <header className={styles.header}>
            <Text tag="h1" view="title" className={styles.header_title} clamp={2}>{title}</Text>

            {
                withData &&
                <div className={styles.header_user_info}>
                    <div className={styles.user_level}>
                        <Text tag="div" view="caption" className={styles.user_level_title} align="right">Уровень</Text>
                        <Text tag="div" view="heading" className={styles.user_level_name} align="right">{userLevel ? levelNames[userLevel - 1][0] : "Загрузка..."}</Text>
                        <div className={styles.user_level_progress}>
                            <div className={styles.user_level_progress_thumb}
                                
                                style={{
                                    width: `${10 + 90 * (1 - progress)}%`
                                }}
                            />
                        </div>
                    </div>
                    <Image width="40px" height="40px" className={styles.header_user_image} objectFit="cover" src={photo} />
                </div>
            }
        </header>
    )
}
